import { useEffect, useState } from "react";
import { useAcoes, useEstado, useOcupado } from "../estado.jsx";
import { useNavegacao } from "../navegacao.jsx";
import * as api from "../api.js";
import { Botao, Cortina, Escolha, SeloIA } from "../componentes/comuns.jsx";

/*
 * Quanto a IA faz NESTE caso — três modos e "herdar".
 *
 * Era um modal de delegação com quatro escopos, etapa de parada, duas formas de
 * envio e três interruptores: nove decisões para responder uma pergunta, e a
 * soma delas deixava acontecer o que ninguém escolheu. O modo (`src/modo.ts`)
 * responde tudo de uma vez, e os freios deixaram de ser escolha.
 */
const DETALHE = {
  sem_ia: "Gente escreve e decide. O sistema continua cobrando, organizando e dando dono ao que trava.",
  copiloto: "A IA prepara a resposta, a ficha e a tese; alguém confirma com um toque antes de sair.",
  piloto: "A IA conduz: responde, confirma a tese e manda o contrato. Protocolar continua sendo de gente.",
};

const HERDAR = "herdar";

export default function ModalDelegar() {
  const { caso } = useEstado();
  const ocupado = useOcupado();
  const { escolherModoDoCaso } = useAcoes();
  const nav = useNavegacao();
  const fechar = () => nav.ajustar({ delegar: null });
  const atual = caso?.registro?.modo_ia ?? HERDAR;
  const [escolha, setEscolha] = useState(atual);
  /* O modo do escritório entra na opção "herdar": sem ele a pessoa escolheria
     herdar sem saber o quê. Falhar aqui só tira o nome da frase. */
  const [setor, setSetor] = useState(null);
  useEffect(() => {
    let vivo = true;
    api
      .modoDaIA()
      .then((r) => vivo && setSetor(r))
      .catch(() => null);
    return () => {
      vivo = false;
    };
  }, []);

  const modos = setor?.modos ?? [
    { chave: "sem_ia", rotulo: "Sem IA" },
    { chave: "copiloto", rotulo: "Copiloto" },
    { chave: "piloto", rotulo: "Piloto automático" },
  ];
  const opcoes = [
    {
      id: HERDAR,
      titulo: setor ? `Herdar do escritório — ${setor.rotulo}` : "Herdar do escritório",
      detalhe: "O caso segue o modo do escritório e muda junto quando ele mudar.",
    },
    ...modos.map((m) => ({ id: m.chave, titulo: m.rotulo, detalhe: DETALHE[m.chave] })),
  ];

  return (
    <Cortina
      aoFechar={fechar}
      antesDoTitulo={<SeloIA tamanho={20} fonte={9.5} />}
      titulo="A IA neste caso"
      acima="Em qualquer modo, o cliente pedindo uma pessoa, a IA sem certeza e três lembretes sem resposta devolvem o caso a alguém — e fora do horário ela não puxa conversa."
      rodape={
        <Botao
          rotulo="Aplicar"
          aoTocar={() => escolherModoDoCaso(escolha === HERDAR ? null : escolha)}
          desabilitado={escolha === atual || ocupado === "delegar"}
          destaque
          largo
          classe="min-w-[150px] rounded-xl bg-verde p-[13px] text-corpo hover:bg-verde/85"
        />
      }
    >
      <Escolha rotulo="Modo da IA neste caso" valor={escolha} aoEscolher={setEscolha} opcoes={opcoes} />
    </Cortina>
  );
}
